// * 首页地址（默认）
export const HOME_URL: string = '/layout/index'

// * 默认主题颜色
export const DEFAULT_PRIMARY: string = '#F77900'

// * Tabs（白名单地址，不需要添加到 tabs 的路由地址）
export const TABS_WHITE_LIST: string[] = ['/403', '/404', '/500', '/layout']

/**copyright中的显示内容 */
export const COPYRIGHT = {
  /**主体中文名 */
  COMPANY: '亲聆网络科技有限公司',
  /**起始年份 */
  YEAR_FROM: '2016',
  /**网安备备案显示信息 */
  WANGAN_NO: '',
  /**ICP备案显示信息 */
  ICP_NO: ''
}

/**rsa公钥 */
export const PUBLIC_KEY = ''

/**项目代号code（同仓库名） */
export const PROJECT_CODE = 'CZM_Data_Center'
